@if (publisher?.avatarBase64) {
  <ion-avatar>
    <img src="{{ publisher.avatarBase64 }}" />
  </ion-avatar>
} @else {
  <div>{{ initials }}</div>
}
